angular.module('impactx.ruleset').controller('RuleUserMinAmountCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'RuleUserService',
    'TranslationService',
    'ToolbarService',
    RuleUserMinAmountCtrl]);

function RuleUserMinAmountCtrl($scope, dataGen, $routeParams, RuleUserService, TranslationService, ToolbarService) {
    var self = this;

    dataGen.getData($scope, {ateId: $routeParams.ATEId, atpId: $routeParams.ATPId}, '/ruleuser/minamount/view')
        .then(function () {
            $scope.trns.delete = TranslationService.get('delete');
            $scope.trns.save = TranslationService.get('save');

            defineButtons();
        });

    self.saveRuleUser = function () {
        return RuleUserService.saveRuleUser($scope);
    };

    self.deleteRuleUser = function () {
        return RuleUserService.deleteRuleUser($scope);
    };

    self.toggleRuleUserType = function (ruleType) {
        RuleUserService.toggleRuleUserType($scope, ruleType);
    };

    self.hasNoSelectedApprover = function () {
        return RuleUserService.hasNoSelectedApprover($scope);
    };

    self.clearChangeType = function (notificationEnabled, modificationEnabled) {
        RuleUserService.clearChangeType($scope, notificationEnabled, modificationEnabled)
    };

    self.setRoles = function (selected) {
        // only a concrete role (id > 0) clears the other approver fields - the empty option
        // must not wipe responsibilities, users and rule user types (IOBL-15516)
        if (selected && selected.id > 0) {
            $scope.data.roles.selected = selected;
            $scope.data.responsibilities.selected = null;
            $scope.data.users.selected = null;
            self.toggleRuleUserType();
        }
    };

    self.setResponsibilities = function (selected) {
        if (selected) {
            $scope.data.roles.selected = null;
            $scope.data.responsibilities.selected = selected;
            $scope.data.users.selected = null;
            self.toggleRuleUserType();
        }
    };

    self.setUsers = function (selected) {
        if (selected) {
            $scope.data.roles.selected = null;
            $scope.data.responsibilities.selected = null;
            $scope.data.users.selected = selected;
            self.toggleRuleUserType();
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.saveRuleUser,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpression: {valueFunction: disableSave, error: $scope.trns.selectOneApprover}
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteRuleUser,
                type: 'dialogaction',
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function disableSave() {
        return self.hasNoSelectedApprover();
    }
}